import api from '@/services/api';

const searchCovered = (term) => api()
  .get(`activities/autocomplete?q=${term}`);

const getAllActivities = () => api()
  .get('activities?perPage=1000&filters=enabled:eq:true');

const searchIndustries = () => api()
  .get('industries');

const searchCategories = (id) => api()
  .get(`industries/${id}/categories`);

const searchActivities = (industryId, categoryId) => api()
  .get(`industries/${industryId}/categories/${categoryId}`);

const getActivityFromId = (id) => api()
  .get(`activities/${id}`);

const getActivitiesfromGrid = (id) => api()
  .get(`grids/${id}/activities`);

const getActivitiesfromGrids = (ids) => api()
  .get(`activities?perPage=1000&filters=grids.id:in:(${ids.join('%7C%7C')})&enabled:eq:true`);

export {
  getAllActivities,
  searchActivities,
  searchCovered,
  searchIndustries,
  searchCategories,
  getActivityFromId,
  getActivitiesfromGrid,
  getActivitiesfromGrids,
};
